import { fromJS } from 'immutable';

const excludedBillingCountriesByBrand = fromJS({
    MANDO: ['JP']
});

export default excludedBillingCountriesByBrand;
